import { useCallback, useRef } from 'react';
import { usePlayerEvent } from './use-player-event';
export const useProgressChanged = (player, onChange) => {
  const lastUpdateTimeRef = useRef();
  const updateIntervalInSeconds = 0.5;
  const handleTimeUpdate = useCallback(() => {
    if (onChange && player) {
      const mediaComposition = player.getMediaComposition();
      const currentTime = player.currentTime();
      const shouldTriggerUpdate = !lastUpdateTimeRef.current || Math.abs(lastUpdateTimeRef.current - currentTime) >= updateIntervalInSeconds;
      if (shouldTriggerUpdate && mediaComposition) {
        onChange(currentTime, mediaComposition);
        lastUpdateTimeRef.current = currentTime;
      }
    }
  }, [onChange, player]);
  usePlayerEvent(player, 'timeupdate', handleTimeUpdate);
};